/* ==========================================================================
   Gravurvorschau im Simaru-Warenkorb
   - [data-sim-engr] oeffnet die Vorschau gross in einem Dialog
     (Bild direkt, Fotogravur-Vorschau als eingebettete Seite)
   - Fotogravur: die gespeicherte Kundenvorschau (customer-preview.html)
     verkleinert als Miniatur; gezeigt wird nur der Bildbereich der Seite
   ========================================================================== */
(function () {
  'use strict'
  if (window.SimEngravingPreview) return
  window.SimEngravingPreview = true

  var dialog = null
  var opener = null

  function build() {
    dialog = document.createElement('dialog')
    dialog.className = 'sim-engr-dialog'
    dialog.setAttribute('aria-labelledby', 'SimEngrTitle')
    dialog.innerHTML =
      '<div class="sim-engr-dialog__head">' +
        '<p class="sim-engr-dialog__title" id="SimEngrTitle">Deine Gravurvorschau</p>' +
        '<button type="button" class="sim-engr-dialog__close" aria-label="Vorschau schließen">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="sim-engr-dialog__body"></div>'
    dialog.querySelector('.sim-engr-dialog__close').addEventListener('click', function () { dialog.close() })
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return
      var r = dialog.getBoundingClientRect()
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close()
    })
    dialog.addEventListener('close', function () {
      dialog.querySelector('.sim-engr-dialog__body').replaceChildren()
      if (opener && opener.isConnected) opener.focus({ preventScroll: true })
      opener = null
    })
    document.body.appendChild(dialog)
  }

  function open(link) {
    if (!dialog) build()
    var url = link.getAttribute('data-sim-engr')
    var frame = link.hasAttribute('data-sim-engr-frame')
    var body = dialog.querySelector('.sim-engr-dialog__body')
    var node
    if (frame) {
      node = document.createElement('iframe')
      node.title = 'Deine bestätigte Gravurvorschau'
      node.referrerPolicy = 'no-referrer'
      node.src = url
    } else {
      node = document.createElement('img')
      node.alt = 'Vorschau deiner Gravur'
      node.src = url
    }
    body.replaceChildren(node)
    dialog.classList.toggle('is-frame', frame)
    opener = link
    dialog.showModal()
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-sim-engr]')
    if (!link || e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return
    if (typeof HTMLDialogElement !== 'function') return
    e.preventDefault()
    open(link)
  })

  // ESC schliesst nur die Vorschau, nicht zusaetzlich den Warenkorb-Drawer
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dialog && dialog.open) {
      e.stopImmediatePropagation()
      e.preventDefault()
      dialog.close()
    }
  }, true)

  /* ------------------------------------- Fotogravur als kleine Miniatur */
  // customer-preview.html bei 320 x 420 px: Vorschaubild bei x 20 / y 63.5,
  // 280 x 273 px. Ausschnitt: quadratisch um die Gravurflaeche im unteren
  // Teil des Anhaengers, damit das Motiv in der Miniatur moeglichst gross ist.
  var FRAME_W = 320
  var FRAME_H = 420
  var CROP = 210
  var CROP_X = 55
  var CROP_Y = 115

  function fit(link) {
    var frame = link.querySelector('iframe')
    if (!frame || !link.clientWidth) return
    var s = link.clientWidth / CROP
    frame.style.transform = 'scale(' + s + ') translate(' + (-CROP_X) + 'px, ' + (-CROP_Y) + 'px)'
  }

  function thumbnail(link) {
    link.setAttribute('data-sim-engr-ready', '')
    var url = link.getAttribute('data-sim-engr') || ''
    if (url.indexOf('https://simaru-gravur-pilot.onrender.com/customer-preview.html#') !== 0) return
    var frame = document.createElement('iframe')
    frame.className = 'sim-line__engr-frame'
    frame.title = 'Deine bestätigte Gravurvorschau (Miniatur)'
    frame.setAttribute('aria-hidden', 'true')
    frame.tabIndex = -1
    frame.referrerPolicy = 'no-referrer'
    frame.loading = 'lazy'
    frame.width = FRAME_W
    frame.height = FRAME_H
    frame.addEventListener('load', function () { link.classList.add('has-image') })
    frame.src = url
    link.insertBefore(frame, link.firstChild)
    fit(link)
  }

  function scan() {
    var links = document.querySelectorAll('[data-sim-engr-design]:not([data-sim-engr-ready])')
    for (var i = 0; i < links.length; i++) thumbnail(links[i])
  }

  var pending = false
  new MutationObserver(function () {
    if (pending) return
    pending = true
    window.requestAnimationFrame(function () { pending = false; scan() })
  }).observe(document.documentElement, { childList: true, subtree: true })
  window.addEventListener('resize', function () {
    var links = document.querySelectorAll('[data-sim-engr-ready]')
    for (var i = 0; i < links.length; i++) fit(links[i])
  })
  scan()
})()
